export default "__VITE_ASSET__3651bc71__"